import { inject, Injectable, REQUEST } from '@angular/core';
import { environment } from '../../../environments';

@Injectable({
  providedIn: 'root',
})
export class ApiConfigService {
  protected request = inject(REQUEST);

  public url(urlParts: string): string {
    return `${environment.baseUrl}/${urlParts}`;
  }

  /**
   * Returns the host url
   * @param urlParts
   * @returns
   */
  public hostUrl(urlParts: string): string {
    return `${this.getHost()}/${urlParts}`;
  }

  /**
   * Host api endpoint
   * @param urlParts
   * @returns
   */
  public hostApiUrl(urlParts: string): string {
    return this.hostUrl(`api/v1/${urlParts}`);
  }

  /**
   * Payment microservice endpoint
   * @param urlParts
   * @returns
   */
  public paymentMsUrl(urlParts: string): string {
    return `${environment.paymentMsUrl}/${urlParts}`;
  }

  public getHost(): string {
    if (this.request) {
      const host = this.request.headers.get('host');

      if (!host) {
        throw new Error('Host header not found');
      }

      const protocol = this.request.url.split(host)[0];

      return `${protocol}${host}`;
    }

    return `${globalThis.location.protocol}//${globalThis.location.host}`;
  }

  public getUniversalLink(urlParts: string): string {
    return `${environment.universalURL}${urlParts}`;
  }
}
